(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sam-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function handleHash(container, shouldScroll) {
      var targetId = decodeURIComponent(window.location.hash || '').replace('#', '');

      if (!targetId) {
        return;
      }

      var details = document.getElementById(targetId);

      if (details && container.contains(details) && !details.open) {
        details.open = true;
        details.setAttribute('open', 'open');

        if (shouldScroll && typeof details.scrollIntoView === 'function') {
          details.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }

    var init = function () {
      document.querySelectorAll('[data-sam-accordion]').forEach(function (container) {
        handleHash(container, true);

        window.addEventListener('hashchange', function () {
          handleHash(container, false);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
